import {FieldArray, reduxForm} from 'redux-form';
import {form} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormActions, FormBody} = form;
import ImportPolozkyFieldArray from "./fields/ImportPolozkyFieldArray";
import './ImportPolozkyForm.scss';
import {withTranslation} from "react-i18next";

/**
 * Formulář pro editaci importovaných fakturačních položek.
 */
class ImportPolozkyForm extends Component {

    static formName = 'ImportPolozkyForm';

    render() {
        const {onClose, submitting, handleSubmit, initialValues, t} = this.props;
        const hasPolozky = initialValues && initialValues.polozky && initialValues.polozky.length > 0;
        return <Form onSubmit={handleSubmit} horizontal className="import-polozky-form">
            <FormBody>
                <FieldArray name="polozky" component={ImportPolozkyFieldArray} />
            </FormBody>
            <FormActions onClose={onClose} storeButton={hasPolozky} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

export default withTranslation()(reduxForm({
    form: ImportPolozkyForm.formName,
})(ImportPolozkyForm));
